import { createSelector } from '@reduxjs/toolkit';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

interface StateProps {
    cms: CmsValue;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DispatchProps {}

interface OwnProps {
    isEarn: boolean;
    onToggleChange: (isEarn: boolean) => void;
}
export type EarnBurnToggleProps = StateProps & DispatchProps & OwnProps;

export const mapStateToProps = createSelector(selectCmsFromBootstrap, (cms): StateProps => {
    return {
        cms,
    };
});
